<template>
  <div class="Other"> 
            
    <a-scene
      landing-page
      xrextras-almost-there
      xrextras-loading
      xrextras-runtime-error
      renderer="colorManagement: true; physicallyBasedRendering: true;"
      xrweb="disableWorldTracking: false">

      <a-assets>
        <img id="logo" src="https://romeosgin-bouteille.dpt.media/static/scan.png" crossorigin="anonymous">
        <a-asset-item :id="glb" :src="'https://romeosgin-bouteille.dpt.media/static/'+ glb +'.glb'"></a-asset-item>
        <a-asset-item id="snake" :src="'https://romeosgin-bouteille.dpt.media/static/snake.glb'"></a-asset-item>
      </a-assets>

      <a-camera
        position="0 1 1"
        raycaster="objects: .cantap"
        cursor="fuse: false; rayOrigin: mouse;">
      </a-camera>

      <a-light type="directional" intensity="1.5" position="0 1 0"></a-light>
      <a-light type="ambient" intensity="0.25"></a-light>

      <xrextras-named-image-target name="romeo"> 

        <!--  
        <a-entity 
          gltf-model="https://romeosgin-bouteille.dpt.media/static/snake.glb"
          cube-env-map = "path: https://romeosgin-vitrine.dpt.media/static/cube-env/; extension: png; reflectivity: .9;"
          scale="2.25 2.25 2.25">
          <a-animation attribute="visible" dur="500" from="false"  repeat="0"></a-animation>
        </a-entity> 
        -->

        <xrextras-curved-target-container color="transparent" beans-spawn></xrextras-curved-target-container>
      </xrextras-named-image-target>

    </a-scene>
   
    <div class="Other__layers" :class="{ 'active': object_is_ready }">

      <transition name="Other__video">
        <div class="Other__video" v-if="use_video">      
          <video ref="video" width="100%" height="100%" playsinline autoplay loop muted>
            <source 
                :src="require('@/commons/video/water-small.webm')" 
                type="video/webm">
            <source 
                :src="require('@/commons/video/water-small.mp4')" 
                type="video/mp4">
          </video> 
        </div>
      </transition>

      <div class="Other__layers-scan" v-if="welcome"> 
        <div class="Other__layers-description">
          <div v-if="lang == 'en'">SCAN THE <span class="green">V</span> ON</br>THE BOTTLE</div>
          <div v-else>SCANNE LE <span class="green">V</span> SUR</br>LA BOUTEILLE</div>
        </div>
        <div class="Other__V">
          <img :src="require('@/commons/img/v.png')"/>
        </div>
        <div class="Other__layers-bottom"></div>
        <div class="Other__load">
          <img  :src="require('@/commons/img/v.gif')"/>
        </div>
      </div>

      <div class="Other__layers-animation" v-if="animated">    
        <div class="Other__layers-gif">
          <img :src="require('@/commons/img/v.gif')"/>
        </div>
      </div>
      <div class="Other__layers-presentation" v-if="presentation">      
        <div class="Other__layers-logo padding">
          <img :src="require('@/commons/img/logo.png')"/>
        </div>
        <div class="Other__layers-plus">
          <img :src="require('@/commons/img/plus.png')"/>
        </div>
        <div class="Other__layers-fvckrender">
          <img :src="require('@/commons/img/fvckrender.png')"/>
        </div>
        <div class="Other__layers-presente">
          <span v-if="lang == 'en'">present</span>
          <span v-else>présentent</span>
        </div>
      </div>
      <div class="Other__layers-sequence" v-if="sequence">      
        <div>SÉQUENCE</br>AR</div>
        <div class="Other__simulation">Simulation durée</br>10 sec</div>
      </div>
      <div class="Other__layers-buttons" v-if="buttons">      
        <div class="Other__layers-logo">
          <img :src="require('@/commons/img/logo.png')"/>
        </div>
        <div class="Other__layers-plus">
          <img :src="require('@/commons/img/plus.png')"/>
        </div>
        <div class="Other__layers-fvckrender padding-bottom">
          <img :src="require('@/commons/img/fvckrender.png')"/>
        </div>
        <div class="Other__layers-button" @click="onClick('discover')">
          <img v-if="lang == 'en'" :src="require('@/commons/img/button-discover.png')"/>
          <img v-else :src="require('@/commons/img/button-decouvrir.png')"/>
        </div>
         <div class="Other__layers-button" @click="onClick('buy')">
          <img v-if="lang == 'en'" :src="require('@/commons/img/button-buy.png')"/>
          <img v-else :src="require('@/commons/img/button-acheter.png')"/>
        </div>
        <div class="Other__layers-button" @click="onClick('fvckrender')">
          <img :src="require('@/commons/img/button-fvckrender.png')"/>
        </div>
        <div class="Other__layers-button" @click="onClick('rg')">
          <img :src="require('@/commons/img/button-rg.png')"/>
        </div>
      </div>

      <transition name="Other__toggle">
        <div class="Other__toggle" :class="{ 'is-on': is_on }" @click="onToggle()" v-if="use_toogle">
          <div class="Other__toggle-circle"/>
        </div>
      </transition>

      <transition name="Other__refresh">
        <div class="Other__refresh" @click="refresh()" v-if="use_refresh">
          <img :src="require('@/commons/img/reload.png')"/>
        </div>
      </transition>

    </div>
    
  </div>
</template>

<script>

import gsap from "gsap"

export default {

    name: 'Other',

    data: ()=>({
        welcome: false,
        animated: false,
        presentation: false,
        sequence: false,
        buttons: false,
        scan_removed: false,
        presentation_completed: false,
        use_sequence: false,
        use_video: false,
        use_toogle: false,
        use_refresh: false,
        object_is_ready: false,
        model: null,
        gbl: null,
        is_on: false,
        is_bc: false
    }),

    beforeCreate() {

      AFRAME.registerComponent('beans-spawn', {
        xrimagescanningCompleted: ()=> {
          this.addWelcome()     
        },
        xrimagefoundCompleted: (scene, detail)=> {
          // duo.setAttribute('visible', 'false') 
          this.updateDetail(scene, detail)
          if(this.scan_removed == false){
            this.scan_removed = true
            this.removeScan()
          }
        },
        xrimageupdatedCompleted: (scene, detail)=> {
          if(this.presentation_completed && this.use_sequence == false){
            this.use_sequence = true
          } 
          else if(this.object_is_ready == true) 
            this.updateObject3D(detail) 
        },
        init() {
          const { object3D } = this.el
          const scene = this.el.sceneEl
          // const duo = scene.querySelector('#duo')
          const xrimagescanning = ({ detail })=> this.xrimagescanningCompleted()
          const xrimagefound = ({ detail })=> this.xrimagefoundCompleted(scene, detail)
          const xrimageupdated = ({ detail })=> this.xrimageupdatedCompleted(scene, detail)
          const xrimagelost = (e)=> {
            // duo.setAttribute('visible', 'false') 
          }
          scene.addEventListener('xrimagescanning', xrimagescanning)
          scene.addEventListener('xrimagefound',  xrimagefound)
          scene.addEventListener('xrimageupdated', xrimageupdated)
          scene.addEventListener('xrimagelost', xrimagelost)
        },   
      })

    },

    created() {
      this.glb = 'elements'
    },

    mounted() {
      // window.alert('onToggle ... ')

      this.checkIP()

    },

    methods: {

      refresh() {
        const reload = this.$router.resolve({ query: { forceReload: undefined } })
        window.location.href = reload.href
      },

      onToggle() {
        this.is_on = !this.is_on
        this.use_video = !this.use_video
      },

      checkIP() {
        const getIP = 'https://api.ipify.org?format=json' 
        this.axios({
          method: 'get',
          url: getIP,  
        })
        .then((res)=> {
          console.log('ONE');  
          console.log(res);
          this.ip = res.data.ip
          this.axios({
            method: 'get',
            url: 'https://ipapi.co/'+ this.ip +'/json/',  
          })
          .then((res)=> {
            // console.log('TWO');
            // console.log(res.data.region_code)
            this.is_bc = res.data.region_code == 'BC' ? true : false
          })
        }) 
      },

      onClick(arg) {
        const uri = {
          discover : "https://fr.romeosgin.com/product/romeos-gin-v/",
          buy: "https://www.saq.com/fr/14824001",
          fvckrender: " https://www.instagram.com/fvckrender/?hl=en",
          rg: "https://www.romeosgin.com/"
        }

        if(this.is_bc) window.open('https://www.bcliquorstores.com/product/486790', '_blank')
        else window.open(uri[arg], '_blank')
      },

      addWelcome() {
        this.welcome = true
        this.$nextTick(()=>{  
          gsap.from(['.Other__layers-description', '.Other__V'], 
            {   
              y: 100, 
              ease: "cubic.out", 
              alpha: 0, 
              delay: 1.5,
              stagger: .15
            })
        })
      },

      temporisation() {
        this.animated = true
        gsap.delayedCall(.15, ()=> this.welcome = false)
        gsap.delayedCall(.25, ()=> this.use_toogle = true)
        gsap.delayedCall(.4, ()=> gsap.to('.Other__layers-animation', { opacity: 0, ease: 'linear.easeNone', duration: .1, onComplete: ()=> this.animated = false })
        )

        gsap.delayedCall(2, ()=>{ 
          this.presentation = true
          this.$nextTick(()=>{ this.showPresentation() })  
        })
      },

      updateDetail(scene, detail) {
        this.$detail = detail
        this.$scene = scene
        // if(this.model)
        //   this.model.setAttribute('visible', 'true') 
      },

      removeScan() {
        gsap.to('.Other__layers-description', { opacity: 0, y: -30, 
          duration: .25,
          onComplete: ()=>{ this.temporisation() } 
        })
      },

      showPresentation() {
        this.addSequence(this.$scene, this.$detail)
        gsap.from(['.Other__layers-logo', '.Other__layers-plus', '.Other__layers-fvckrender', '.Other__layers-presente'], 
            {   
              y: 100, 
              ease: "cubic.out", 
              alpha: 0, 
              delay: 1,
              stagger: .15,
              onComplete: ()=>{
                gsap.delayedCall(2, ()=>{ this.hidePresentation() })
              } 
            })
      },

      hidePresentation() {
        gsap.to(['.Other__layers-logo', '.Other__layers-plus', '.Other__layers-fvckrender', '.Other__layers-presente'], 
            {   
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: { each: .15, from: 'end' },
              onComplete: ()=>{ 
                this.presentation_completed = true 
                // this.addSequence(this.$scene, this.$detail)
              }
            })
      },

      addSequence(scene, detail) {
        // this.sequence = true
        this.addObject3D(scene, detail)
        // this.$nextTick(()=>{ this.showSequence() })  
      },

      beforeShowButtons() {
        gsap.delayedCall(19, ()=> this.use_toogle = false)
        gsap.delayedCall(20, ()=>{ 
          this.buttons = true
          this.$nextTick(()=>{ this.showButtons() })  
        })
      },

      addObject3D(scene, detail) {

        const absPos = new THREE.Vector3().copy(this.$detail.position)
        setTimeout(() => {
          this.model = document.createElement('a-entity')
          this.model.setAttribute('visible', 'false')
          this.model.setAttribute('gltf-model', 'https://romeosgin-bouteille.dpt.media/static/'+ this.glb +'.glb')
          this.model.setAttribute('cube-env-map', { path: "https://romeosgin-bouteille.dpt.media/static/cube-env/", extension: 'png', reflectivity: .9 })
          this.model.setAttribute('shadow', { receive: false })
          this.model.setAttribute('animation-mixer', { clip: 'Animation', loop: 'repeat' })
          
          this.model.object3D.position.set(absPos.x, absPos.y-.4, absPos.z-.2)
          this.model.object3D.scale.set(this.$detail.scale*1.8, this.$detail.scale*1.8, this.$detail.scale*1.8)
          
          scene.appendChild(this.model)

          this.model.addEventListener('model-loaded', ()=> {

            // this.model.setAttribute('animation-mixer', { 
            //   clip: 'Animation', 
            //   loop: 'once', 
            //   clampWhenFinished: true 
            // })

            this.model.setAttribute('visible', 'true') 
            this.object_is_ready = true
            this.beforeShowButtons()
          })
        }, 250)
      },

      updateObject3D(detail) {
        const absPos = new THREE.Vector3().copy(this.$detail.position)
        this.model.object3D.position.set(absPos.x, absPos.y-.8, absPos.z-.2)
        // this.model.object3D.scale.set(this.$detail.scale*1.8, this.$detail.scale*1.8, this.$detail.scale*1.8)
      },

      showSequence() {
        gsap.from(['.Other__layers-sequence'], 
            {   
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: .15
            })

        gsap.delayedCall(22, ()=>{ 
          this.sequence = false
          this.buttons = true
          this.$nextTick(()=>{ this.showButtons() })  
        })
      },

      showButtons() {

        gsap.delayedCall(3, ()=> this.use_refresh = true)
        
        gsap.from(['.Other__layers-logo', '.Other__layers-plus', '.Other__layers-fvckrender', '.Other__layers-button'], 
            {   
              y: 100, 
              ease: "cubic.out", 
              alpha: 0, 
              delay: .2,
              stagger: .15
            })
      }
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Other
  overflow hidden
  position absolute
  width 100%
  height 100%
  color white
  // background #409171
  font-family gotham

  &__load
    position fixed
    opacity 0
    top -500
  
  &__V  
    // width 60%
    width 30vh

  &__refresh 
    position absolute
    top 18px
    right 20px
    width 28px
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0


  &__toggle
    position absolute
    bottom 20px 
    right 20px
    border 3px solid white
    border-radius 16px
    width 60px
    height 28px
    display flex
    align-items center
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0

    &.is-on
      justify-content flex-end

    &-circle 
      width 22px
      height 22px
      background white
      border-radius 50%
      margin 3px

  &__layers 
    pointer-events none
    width 100% 
    height 100% 
    top 0px
    left 0px
    position fixed
    z-index 10000

    &.active 
      pointer-events auto

    &-scan 
    &-animation 
    &-sequence
    &-buttons
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content center
      width 100%
      height 100%

    &-sequence 
      font-size 48px
      text-align center
      color black

    &-description 
      font-size 22px 
      padding 24px
      text-align center

    &-bottom 
      width 100%
      height 98px

    &-gif
      // width 60%
      width 30vh

    &-presentation
      position absolute
      display flex 
      flex-direction column
      align-items center
      justify-content flex-start
      width 100%
      height 100%

    &-logo 
      // width 60%
      width 30vh

      &.padding
        padding-top 20%

    &-fvckrender
      // width 60%
      width 30vh
      padding-top 16px

      &.padding-bottom 
        // padding-bottom 16px
        padding-bottom 4vh

    &-plus 
      width 24px

    &-presente 
      padding-top 32px
      text-transform uppercase
      font-size 16px

    &-button
      // padding 12px 16px 0
      padding 2vh 4vh 0
      // width 50vh

  &__simulation 
    font-size 16px
    padding-top 32px
    color black

  &__video
    position absolute
    top 0
    left 0 
    opacity .6
    width 100%
    height 100%
    transition opacity 1s 

    &-enter
    &-leave-active
      opacity 0
    
    & video 
      width 100vw 
      object-fit fill

.green 
  color #64c39e

#requestingCameraPermissions 
  color black
  background-color black
  opacity 0
  position absolute 
  width 1000px

.poweredby-img
  opacity 0 !important
  display none

.button-primary-8w 
  background-color green
  color #fff

</style>














